
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/what-is-drop-and-hook-freight",
      function () {
        return require("private-next-pages/content/what-is-drop-and-hook-freight.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/what-is-drop-and-hook-freight"])
      });
    }
  